import { render, staticRenderFns } from "./DetailSearchGudang.vue?vue&type=template&id=331ae857&scoped=true&"
import script from "./DetailSearchGudang.vue?vue&type=script&lang=js&"
export * from "./DetailSearchGudang.vue?vue&type=script&lang=js&"
import style0 from "./DetailSearchGudang.vue?vue&type=style&index=0&id=331ae857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ae857",
  null
  
)

export default component.exports